import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../Components/SideBar.js";
import { API_BASE_URL } from "../config.js";

// استيراد ملف التنسيق الخاص بالطبيب لتوحيد التصميم
import "./doctor_profile.css"; 

export default function AdminProfile() {
  const navigate = useNavigate();
  
  const [adminData, setAdminData] = useState({
    id: "",
    username: "",
    real_name: "",
    phon_number: "",
    email: "",
  });
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          navigate("/login");
          return;
        }

        const currentUsername = localStorage.getItem("username");

        const response = await fetch(`${API_BASE_URL}/users/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          const users = Array.isArray(data) ? data : data.results || [];
          
          const currentAdmin = users.find(
            (u) => u.username === currentUsername || u.phon_number === currentUsername
          );

          if (currentAdmin) {
            setAdminData({
              id: currentAdmin.id,
              username: currentAdmin.username || "",
              real_name: currentAdmin.real_name || "مدير النظام",
              phon_number: currentAdmin.phon_number || "",
              email: currentAdmin.email || "",
            });
          }
        } else {
          console.error("فشل في جلب بيانات المسؤول");
        }
      } catch (error) {
        console.error("حدث خطأ في الاتصال بالخادم:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [navigate]);

  const showNotificationMsg = (message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: "", type: "" });
    }, 4000);
  };

  const handlePasswordUpdate = async () => {
    if (!password || password.length < 6) {
      showNotificationMsg("يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.", "error");
      return;
    }

    setSaving(true);
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(`${API_BASE_URL}/users/${adminData.id}/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password: password }),
      });

      if (response.ok) {
        showNotificationMsg("تم تحديث كلمة المرور بنجاح!", "success");
        setPassword("");
      } else {
        showNotificationMsg("حدث خطأ أثناء تحديث كلمة المرور.", "error");
      }
    } catch (error) {
      showNotificationMsg("تعذر الاتصال بالخادم.", "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f4f7fb]" dir="rtl">
        <div className="text-center">
          <i className="fa-solid fa-circle-notch fa-spin text-3xl text-[#0b4f6f] mb-3"></i>
          <p className="text-gray-600 font-bold">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-wrapper" dir="rtl">
      <SideBar role="admin" />
      
      <main className="profile-main-content">
        {/* إشعارات التحديث */}
        <div className={`toast-notification ${notification.show ? 'show' : ''} ${notification.type}`}>
          {notification.message}
        </div>

        {/* الهيدر المتطابق مع صفحة الطبيب */}
        <div className="profile-header-card">
          <div className="header-info">
            <p className="subtitle">إدارة حسابك وإعدادات الأمان</p>
            <h2 className="doctor-name">أ. {adminData.real_name}</h2>
            <span className="doctor-badge">مدير النظام</span>
          </div>
        </div>

        {/* تم تحويل الشبكة لتعرض الأقسام بشكل عمودي لكي تأخذ العرض الكامل دائماً */}
        <div className="profile-sections-grid" style={{ display: "flex", flexDirection: "column" }}>
          
          {/* قسم المعلومات الشخصية (للقراءة فقط) */}
          <section className="profile-card">
            <h3 className="card-title">المعلومات الشخصية</h3>
            {/* توزيع الحقول على عمودين لتتناسب مع العرض الكامل */}
            <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.5rem" }}>
              
              <div className="input-group readonly-group">
                <label>الاسم الكامل</label>
                <div className="input-wrapper">
                  <i className="fa-solid fa-address-card icon"></i>
                  <input
                    type="text"
                    value={adminData.real_name}
                    readOnly
                  />
                </div>
              </div>

              <div className="input-group readonly-group">
                <label>اسم المستخدم</label>
                <div className="input-wrapper">
                  <i className="fa-solid fa-user icon"></i>
                  <input 
                    type="text" 
                    value={adminData.username} 
                    readOnly 
                    dir="ltr" 
                  />
                </div>
              </div>

              <div className="input-group readonly-group">
                <label>رقم الهاتف</label>
                <div className="input-wrapper">
                  <i className="fa-solid fa-phone icon"></i>
                  <input
                    type="tel"
                    value={adminData.phon_number}
                    readOnly
                    dir="ltr"
                  />
                </div>
              </div>

              <div className="input-group readonly-group">
                <label>البريد الإلكتروني</label>
                <div className="input-wrapper">
                  <i className="fa-solid fa-envelope icon"></i>
                  <input
                    type="email"
                    value={adminData.email}
                    readOnly
                    dir="ltr"
                  />
                </div>
              </div>

            </div>
          </section>

          {/* قسم إعدادات الأمان */}
          <section className="profile-card">
            <h3 className="card-title">إعدادات الأمان</h3>
            <div className="form-grid">
              <div className="input-group">
                <label>كلمة المرور الجديدة</label>
                <div className="input-wrapper">
                  <i className="fa-solid fa-lock icon"></i>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="أدخل كلمة المرور الجديدة..."
                    autoComplete="new-password"
                  />
                  <i
                    className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password`}
                    onClick={() => setShowPassword(!showPassword)}
                  ></i>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* زر التحديث */}
        <div className="profile-actions">
          <button className="btn-primary" onClick={handlePasswordUpdate} disabled={saving}>
            {saving ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                <span>جاري التحديث...</span>
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk"></i>
                <span>تحديث كلمة المرور</span>
              </>
            )}
          </button>
        </div>
      </main>
    </div>
  );
}